import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_f2hc54t1: FaireBrandEntity = {
  token: "b_f2hc54t1",
  type: "brand",
  name: "Slow North",
  avatarUrl:
    "https://cdn.faire.com/fastly/b1942ff9bb80d2bd223041319028d2ba706c9151e3ead0a28ac2e36578edf369.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/04283c812b33ea82dcb0925ed1b971999b5973a366c842cadbee9edff5311765.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/b1942ff9bb80d2bd223041319028d2ba706c9151e3ead0a28ac2e36578edf369.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/04283c812b33ea82dcb0925ed1b971999b5973a366c842cadbee9edff5311765.jpeg",
  location: "Austin, TX, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 308,
  isTopShop: true,
  isInsider: true,
  description:
    "At Slow North, we intentionally craft all-natural, botanical products made to complement simple, whole living. A woman-owned, family-run business, Slow North emerged from the belief that all goods we invite into our homes could be beautiful, intentional, and natural.  What started as a side business pouring candles in my backyard garage in 2015 has turned into a vibrant small-batch manufacturing company with a beautiful team of 8 people helping us make the magic happen every day! From small-batch essential oil candles to weighted neck wrap warmers, we handcraft all our goods from our Austin-based studio. \n\nWe've had a brick-and-mortar shop ourselves since 2017, so we understand first-hand the needs of our stockist partners from timely delivery to high-quality finished goods your customers will love. Our team is committed to helping you be successful, and we hope to build a lifelong connection so we can grow our businesses together. \n\nWe believe in making our business a source of good in the world. Our purpose goes beyond profits, and as we grow as a company, our contribution to our community also grows. We commit to donating 10% of our profits to the Central Texas Food Bank, The SAFE Alliance, RAICES, and KIVA (in the form of micro-loans to emerging small businesses around the world). ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:50.136Z",
    importedBy: "entity-db-cli",
  },
};
